import API from 'services/api';

export const getCooperationTypes = () => {
  return API.get('/api/cooperation-types/all').then(res => res?.data);
};
